import React, { useState, useEffect } from "react";

const Careerpage = () => {
  const [jobs, setJobs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [loading, setLoading] = useState(false); // add this at top

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    resume: null,
    about: ""
  });

  useEffect(() => {
    fetch("https://apiwebsite.paushtikkswitch.com/api/Masters/GetJobList")
      .then((res) => res.json())
      .then((data) => setJobs(data))
      .catch((err) => console.error("Error fetching jobs:", err));
  }, []);

  const openModal = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedJob(null);
    setFormData({
      name: "",
      contact: "",
      email: "",
      resume: null,
      about: ""
    });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true); // show loader

  const data = new FormData();
  data.append("JobId", "1");
  data.append("Name", formData.name);
  data.append("Contact", formData.contact);
  data.append("Email", formData.email);
  data.append("Resume", formData.resume);
  data.append("About", formData.about);
  data.append("Postion", selectedJob.title);

  try {
    const response = await fetch(
      "https://apiwebsite.paushtikkswitch.com/api/Masters/SubmitJobApplication",
      {
        method: "POST",
        body: data,
      }
    );

    if (response.ok) {
      alert("Application submitted successfully!");
      closeModal();
    } else {
      alert("Failed to submit application.");
    }
  } catch (err) {
    console.error(err);
    alert("Error submitting application.");
  } finally {
    setLoading(false); // hide loader after request completes
  }
};

  return (
    <div>
      {/* Hero Section */}
      <section className="heronew" style={{ background: "white" }}>
        <img
          src="img/blogleft.png"
          className="vectorall-left desktopvector"
          alt="left vector"
        />
        <img
          src="img/m2.png"
          className="vectorall-left mobilevector"
          alt="left vector"
        />
        <div className="hero-content">
          <h1 className="headline">
            <span style={{ color: "#2F2F2F" }}>Careers at Paushtikk</span>
          </h1>
        </div>
      </section>

      {/* Dynamic Career Cards */}
      <section className="about-section1 light-section">
        <div className="founders-grid_career">
          {jobs.map((job, index) => (
            <div className="founder-cardcarerr" key={index}>
              <h3><center>Position: {job.title}</center></h3>
              <p><center>{job.description}</center></p>
              <center>
                <button className="subscribe-btn" onClick={() => openModal(job)}>
                  Apply Now
                </button>
              </center>
            </div>
          ))}
        </div>
      </section>

      {/* Modal */}
      {showModal && selectedJob && (
        <div className="modal-overlay">
          <div className="modal-container">
            <h2>Apply for {selectedJob.title}</h2>
            <form onSubmit={handleSubmit}>
              <label>Name:</label>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label>Contact No:</label>
              <input
                type="text"
                name="contact"
                placeholder="Your Contact No"
                value={formData.contact}
                onChange={handleChange}
                required
              />

              <label>Email:</label>
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label>Resume:</label>
              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                required
              />

              <label>Tell us more about yourself:</label>
              <input
                type="text"
                name="about"
                placeholder="Tell us more about yourself"
                value={formData.about}
                onChange={handleChange}
              />

            <button type="submit" className="subscribe-btn" disabled={loading}>
  {loading ? "Please wait..." : "Submit Application"}
</button>
            </form>
            <button className="close-btn" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* Styles */}
      <style>{`
        .founders-grid_career {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          justify-items: center;
        }
        .founder-cardcarerr {
          background: #fff;
          padding: 20px;
          border-radius: 10px;
          height: 400px;
          width: 100%;
          max-width: 400px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .modal-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .modal-container {
          background: white;
          padding: 20px;
          border-radius: 10px;
          width: 400px;
          max-width: 90%;
        }
        .modal-container h2 {
          margin-bottom: 15px;
        }
        .modal-container form {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .close-btn {
          margin-top: 10px;
          background: #ccc;
          padding: 8px 12px;
          border: none;
          cursor: pointer;
          border-radius: 5px;
        }
        input[type="text"], input[type="email"], input[type="file"] {
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 5px;
        }
      `}</style>
    </div>
  );
};

export default Careerpage;
